/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useLanguageByCode } from '@api/hooks';
import { formatLanguageError, getCountryByCode } from '@utils';

import InfoItem from '../InfoItem';

const LanguageItem = ({ code }) => {
  const { language, error } = useLanguageByCode({ code });

  const countryCode = getCountryByCode(language.code);
  const title = error ? formatLanguageError(error) : language.name || 'loading language...';

  return <InfoItem countryCode={countryCode}>{title}</InfoItem>;
};

export default LanguageItem;
